// Card partners
export const CREDIT_KARMA_LIGHTBOX = 'CK_LB';
export const CREDIT_KARMA_INVITE_TO_APPLY = 'CK_ITA';
export const CREDIT_LAND = 'CL';
export const BEST_CREDIT_OFFERS = 'BCO';
export const RED_VENTURES_BANKRATE = 'RV_BR';
export const RED_VENTURES_BANKRATE_ITA = 'RV_BR_ITA';
export const RED_VENTURES_CREDIT_CARDS_DOT_COM = 'RV_CCDC';
export const RED_VENTURES_CREDIT_CARDS_DOT_COM_ITA = 'RV_CCDC_ITA';
export const BULLDOG_CREDIT_SOUP = 'BMG_CS';
export const BULLDOG_CREDIT_SOUP_ITA = 'BMG_CS_ITA';
export const WALLET_HUB = 'WH';
export const WALLET_HUB_ITA = 'WH_ITA';
export const EXPERIAN_INVITE_TO_APPLY = 'EXP_ITA';
export const EXPERIAN_ACTIVATE = 'EXP_ACT';
export const MONEY_LION = 'ML';
export const MONEY_LION_ITA = 'ML_ITA';
export const MASTERCARD = 'RV_MC_ITA';
export const PERPAY_WEBSITE = 'PPW_GEN';
export const GOOGLE_SEARCH_ADS = 'GSA_GEN';
export const INFLUENCER_PROMOTION = 'IFL_GEN';
export const PERPAY_DIRECT_MAIL = 'PPDM_GEN';
export const OUT_OF_HOME_1 = 'OH1_GEN';
export const UBER = 'UBR_GEN';
export const MONEVO = 'MVO';
export const MONEVO_ITA = 'MVO_ITA';
const CREDIT_KARMA_WELCOME_OFFER_50 = 'wb50';
const CREDIT_KARMA_WELCOME_OFFER_100 = 'wb100';

export const WELCOME_OFFER_CODES = [
    CREDIT_KARMA_WELCOME_OFFER_50,
    CREDIT_KARMA_WELCOME_OFFER_100,
];

// Premium Card Experience
export const PremiumCardGroupName = 'premium_card';

// Partner Onboarding Products
export const PARTNER_ONBOARDING_CARD = 'card';
export const PARTNER_ONBOARDING_MARKETPLACE = 'marketplace';

// Marketplace partners
export const CREDIT_KARMA_LIGHTBOX_MKP = 'CK_LB_MKP';
export const CREDIT_KARMA_INVITE_TO_APPLY_MKP = 'CK_ITA_MKP';
export const BULLDOG_CREDIT_SOUP_ITA_MKP = 'BMG_CS_ITA_MKP';

export const CREDIT_KARMA_MARKETPLACE_CODES = [
    CREDIT_KARMA_LIGHTBOX_MKP,
    CREDIT_KARMA_INVITE_TO_APPLY_MKP,
];

// Paychex flow
export const PAYCHEX = 'PAYCHEX';
